import React from 'react';
import { PhotoDisplayData } from '../../types/PhotoDisplayData';
import { useAdminStore } from '../../stores/useAdminStore';
import './InlinePhotoActions.css';
import { BaseInlineActions } from './BaseInlineActions';

interface InlinePhotoActionsProps {
    photo: PhotoDisplayData;
    photoIndex: number;
    totalPhotos: number;
}

export const InlinePhotoActions: React.FC<InlinePhotoActionsProps> = ({
    photo,
    photoIndex,
    totalPhotos
}) => {
    const openPhotoActionsModal = useAdminStore(s => s.openPhotoActionsModal);

    return (
        <BaseInlineActions
            className="inline-photo-actions"
            onClick={() => openPhotoActionsModal(photo, photoIndex, totalPhotos)}
            title="Photo actions"
            ariaLabel="Open photo actions menu"
            data-testid="photo-actions-gear"
        >
            ⚙️
        </BaseInlineActions>
    );
};
